/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GPT } from './GPT';
import type { ValuationApproachPtCompGroup } from './ValuationApproachPtCompGroup';
export type ValuationApproachGPT = {
    readonly id?: number;
    gpt_transactions?: Array<GPT>;
    valuationapproachptcompgroup_set?: Array<ValuationApproachPtCompGroup>;
    valuation_approach: number;
    ltm_revenue_selection?: ValuationApproachGPT.ltm_revenue_selection;
    ltm_ebitda_selection?: ValuationApproachGPT.ltm_ebitda_selection;
    ntm_revenue_selection?: ValuationApproachGPT.ntm_revenue_selection;
    ntm_ebitda_selection?: ValuationApproachGPT.ntm_ebitda_selection;
    deleted_gpt_transactions?: Array<number>;
    deleted_comp_groups?: Array<number>;
    name: string;
    is_deleted?: boolean | null;
    readonly deleted_at?: string | null;
    ltm_revenue_selected_multiple?: string | null;
    ltm_ebitda_selected_multiple?: string | null;
    ntm_revenue_selected_multiple?: string | null;
    ntm_ebitda_selected_multiple?: string | null;
    ltm_revenue_weighting?: string | null;
    ltm_ebitda_weighting?: string | null;
    ntm_revenue_weighting?: string | null;
    ntm_ebitda_weighting?: string | null;
    ntm_revenue_discount?: string | null;
    ntm_ebitda_discount?: string | null;
    weighted_enterprise_value?: string | null;
    percentile_selection_a?: number;
    percentile_selection_b?: number;
    use_adjusted_LTM_ebitda?: boolean;
    use_adjusted_NTM_ebitda?: boolean;
    ntm_revenue_gpc_approach?: number | null;
    ntm_ebitda_gpc_approach?: number | null;
};
export namespace ValuationApproachGPT {
    export enum ltm_revenue_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum ltm_ebitda_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum ntm_revenue_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum ntm_ebitda_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
}

